var render = function render(){var _vm=this,_c=_vm._self._c;return _c('drop',{staticClass:"drop-div",on:{"drop":_vm.onDrop,"dragenter":function($event){return _vm.$emit('dragenter')},"dragover":() => {},"dragleave":function($event){return _vm.$emit('dragleave')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }